import React from 'react'
import styled from 'styled-components'

import Div from '@jarvis.oddle/core/components/Div'
import Card from '@jarvis.oddle/core/components/Card'
import { H4, P } from '@jarvis.oddle/core/components/Typo'
import Checkbox from '@jarvis.oddle/core/components/Checkbox'
import { colors, marginSizes } from '@jarvis.oddle/core/theme/default'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

import useAppSelector from 'src/hooks/useAppSelector'
import { selectOrder } from 'src/redux/order'
import { togglePromotionAction } from 'src/redux/order/action'
import useAppDispatch from 'src/hooks/useAppDispatcher'
import { isItemPromotion } from 'src/utils/promotion'

const StyledCard = styled(Card).attrs(() => ({
  marginBottom: 'small'
}))`
  border-color: ${(props) =>
    props.checked
      ? props.theme.buttonColor || colors.brandPrimary
      : props.theme.colorLinesAndBorders || colors.separator};
  ${(props) => (props.disabled ? 'opacity: 0.5;' : '')};
`

const NonPromoCodePromotion = ({
  promotions,
  goToNextModal
}: {
  promotions: SelectedPromotion[]
  goToNextModal: (modalName, passingProps) => void
}): JSX.Element => {
  const dispatch = useAppDispatch()
  const { t } = React.useContext(TranslationContext)
  const selectedPromotions = useAppSelector(selectOrder).selectedPromotions.data
  const unStackable = selectedPromotions.find((p) => p.stackableOption)

  const handlePromotionSelect = (promotion) => {
    const isSelected = selectedPromotions.some((p) => p.id === promotion.id)
    if (isSelected || !isItemPromotion(promotion.type)) {
      dispatch(togglePromotionAction({ promotion }))
    } else {
      goToNextModal('CheckoutPromotionItemModal', { promotion })
    }
  }

  return (
    <React.Fragment>
      <H4 normalised marginBottom={marginSizes.small} bold>{t('Eligible Promotions')}</H4>
      {promotions.map((promotion, idx) => {
        const checked = selectedPromotions.findIndex((selectedPromo) => selectedPromo.id === promotion.id) > -1
        const disabled = (unStackable && unStackable.id !== promotion.id) || (selectedPromotions.length > 0 && promotion.stackableOption && !checked)
        return (
          <StyledCard
            key={promotion.id}
            disabled={disabled}
            checked={checked}>
            <Checkbox
              name={promotion.id}
              disabled={disabled}
              checked={checked}
              onChange={() => handlePromotionSelect(promotion)}
              controlled>
              {({ checked, disabled }) => (
                <React.Fragment>
                  <Checkbox.Tick data-testid={`checkbox.tick.${idx}`} checked={checked} disabled={disabled} />
                  <Div>
                    <P bold normalised>{promotion.name}</P>
                    <P normalised>{promotion.description}</P>
                  </Div>
                </React.Fragment>
              )}
            </Checkbox>
          </StyledCard>
        )
      })}
    </React.Fragment>
  )
}

export default NonPromoCodePromotion
